import {useEffect, useState} from 'react';
import {useGetDepartmentsInSummary} from '../../../core/repositories/reportSummaryRepository';

type Department = {
  departmentID: number;
  departmentName: string;
};

type Props = {
  reportType: string;
  companyID: number;
  departmentID?: number;
};

export const useHandleReportDepartments = ({
  reportType,
  companyID,
  departmentID,
}: Props) => {
  const [departments, setDepartments] = useState<Department[]>([]);

  const {data: departmentsData} = useGetDepartmentsInSummary({
    companyID,
    queryParams: {reportType},
  });

  useEffect(() => {
    if (!departmentsData?.ok || !departmentsData.value.departments) {
      setDepartments([]);
      return;
    }

    const departmentsWithoutSelected = departmentsData.value.departments.filter(
      (department) => department.departmentID !== departmentID,
    );
    setDepartments(departmentsWithoutSelected);
  }, [departmentsData, departmentID]);

  return {
    departments,
  };
};
